import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';

import "./ArtistMypage.css";
import "../../styles/font.css";
import { TopMenu } from '../../component/TopMenu';
import { API_CONFIG } from '../../config/api';

export const ArtistMypage = () => {
  function getCookie(name) {
    let cookieArray = document.cookie.split(';');
    for (let i = 0; i < cookieArray.length; i++) {
      let cookiePair = cookieArray[i].trim().split('=');
      if (cookiePair[0] === name) {
        return decodeURIComponent(cookiePair[1]);
      }
    }
    return null;
  }
  const navigate = useNavigate();
  const [searchKeyword, setSearchKeyword] = useState('');
  const [artistInfo, setArtistInfo] = useState({
    artist_name: '',
    artist_company: '',
    artist_email: '',
    artist_phone: '',
    artist_description: '',
    artist_address: '',
    artist_lat: '',
    artist_lng: '',
    artist_website: '',
    tour_available: false,
    tour_address: '',
    interests: {
      westernPainting: false,
      koreanPainting: false,
      folkPainting: false,
      waterPainting: false,
      printPainting: false,
      sculpture: false,
      calligraphy: false,
      craft: false,
      picture: false,
      illustration: false
    }
  });

  // 작품 관련 state
  const [artworks, setArtworks] = useState([]);
  const [isArtworkModalOpen, setIsArtworkModalOpen] = useState(false);
  const [editingArtwork, setEditingArtwork] = useState(null);
  const [currentArtwork, setCurrentArtwork] = useState({
    artwork_name: '',
    artwork_size: '',
    artwork_year: new Date().getFullYear(),
    artwork_material: '',
    artwork_description: '',
    artwork_price: '',
    artwork_image: null,
    emotion_tags: [],
    situation_tags: []
  });
  const [previewUrl, setPreviewUrl] = useState(null);

  const emotionTags = [
    '슬픔', '피로', '지침', '불안', '긴장', '혼란', '용기', '무기력',
    '고립감', '답답함', '수치심', '희망', '자책', '향수', '떨림',
    '억울함', '성취감', '외로움', '투명감', '추진력', '소외감',
    '기쁨/행복', '뭉클함'
  ];

  const situationTags = [
    '번아웃', '이별', '이직/퇴사', '펫로스', '인간관계 피로',
    '내면의 혼란', '실패 경험 후', '창작/도전 앞의 긴장',
    '가족 간 갈등', '그냥 그런 날', '반복되는 일상',
    '몸이 아프거나 컨디션 난조', '여행 중',
    '시험이나 학업 스트레스', '돈/경제적 문제로 고민'
  ];

  // 일반 사용자, 예술가 계정으로 로그인 가능. 대상마다 다르게 렌더링
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userType, setUserType] = useState(null); // 'user' or 'artist' or null
  const [userName, setUserName] = useState("");

  const gotoMain = () => {
    navigate('/');
  }

  const handleLogout = () => {
    // 일반 사용자 관련 모든 쿠키 삭제
    document.cookie = "yournest_u_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_u_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";

    // 작가 관련 모든 쿠키 삭제
    document.cookie = "yournest_a_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_login_id=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_name=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_profile=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_company=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_email=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_phone=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_description=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_type=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_address=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_lat=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_lng=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    document.cookie = "yournest_a_auth_token=; path=/; expires=Thu, 01 Jan 1970 00:00:00 UTC";
    
    setIsAuthenticated(false);
    setUserType(null);
    setUserName("");
    alert("로그아웃 되었습니다");
  };
  
  useEffect(() => {
    const artistAuthToken = getCookie('yournest_a_auth_token');
    if (!artistAuthToken) {
      alert('로그인이 필요한 서비스입니다.');
      navigate('/login');
      return;
    }
    fetchArtistInfo();
    fetchArtworks();
  }, []);

  useEffect(() => {
    const artistToken = getCookie('yournest_a_auth_token');
    if (artistToken) {
      verifyArtistToken(artistToken);
    }
  }, []);

  const verifyArtistToken = async (token) => {
    try {
      const response = await fetch(`${API_CONFIG.MAIN}/verify_artist_token`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ auth_token: token }),
      });

      if (response.ok) {
        const data = await response.json();
        setIsAuthenticated(true);
        setUserType('artist');
        setUserName(data.artist_name);
      } else {
        setIsAuthenticated(false);
        setUserType(null);
      }
    } catch (error) {
      console.error('Token verification error:', error);
      setIsAuthenticated(false);
      setUserType(null);
    }
  };

  const fetchArtistInfo = async () => {
    try {
      const artistId = getCookie('yournest_a_id');
      const response = await fetch(`${API_CONFIG.MAIN}/get_artist_info`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ artist_id: artistId })
      });

      if (!response.ok) throw new Error('작가 정보 조회 실패');
      const data = await response.json();
      if (data.isSuccess) {
        setArtistInfo(data.artistInfo);
      }
    } catch (error) {
      console.error('작가 정보 조회 실패:', error);
      alert('작가 정보를 불러오는데 실패했습니다.');
    }
  };

  const fetchArtworks = async () => {
    try {
      const artistId = getCookie('yournest_a_id');
      const response = await fetch(`${API_CONFIG.MAIN}/get_artist_artworks`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ artist_id: artistId })
      });

      if (!response.ok) throw new Error('작품 목록 조회 실패');
      const data = await response.json();
      if (data.isSuccess) {
        // 서버에서 받은 이미지를 URL로 변환하고 역순으로 정렬 (오래된 것이 왼쪽)
        const artworksWithUrls = data.artworks.map(artwork => ({
          ...artwork,
          previewUrl: `${API_CONFIG.MAIN}/uploads/artworks/${artwork.artwork_image}`
        })).reverse();
        setArtworks(artworksWithUrls);
      }
    } catch (error) {
      console.error('작품 목록 조회 실패:', error);
    }
  };

  // 작품 관련 핸들러
  const openArtworkModal = (artwork = null) => {
    if (artwork) {
      setEditingArtwork(artwork);
      setCurrentArtwork(artwork);
      // 기존 이미지의 경우 previewUrl 사용
      if (artwork.previewUrl) {
        setPreviewUrl(artwork.previewUrl);
      } else if (artwork.artwork_image && !(artwork.artwork_image instanceof File)) {
        // 서버에서 가져온 이미지 파일명인 경우 URL로 변환
        setPreviewUrl(`${API_CONFIG.MAIN}/uploads/artworks/${artwork.artwork_image}`);
      }
    } else {
      setEditingArtwork(null);
      setCurrentArtwork({
        artwork_name: '',
        artwork_size: '',
        artwork_year: new Date().getFullYear(),
        artwork_material: '',
        artwork_description: '',
        artwork_price: '',
        artwork_image: null,
        emotion_tags: [],
        situation_tags: []
      });
      setPreviewUrl(null);
    }
    setIsArtworkModalOpen(true);
  };

  const closeArtworkModal = () => {
    setIsArtworkModalOpen(false);
    setEditingArtwork(null);
    // 메모리 누수 방지
    if (previewUrl) {
      URL.revokeObjectURL(previewUrl);
      setPreviewUrl(null);
    }
  };

  const handleModalBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      closeArtworkModal();
    }
  };

  const handleArtworkImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // 기존 preview URL 해제
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
      }
      // 새 preview URL 생성
      const newPreviewUrl = URL.createObjectURL(file);
      setPreviewUrl(newPreviewUrl);
      setCurrentArtwork({...currentArtwork, artwork_image: file});
    }
  };

  const toggleEmotionTag = (tag) => {
    const tags = currentArtwork.emotion_tags.includes(tag)
      ? currentArtwork.emotion_tags.filter(t => t !== tag)
      : [...currentArtwork.emotion_tags, tag];
    setCurrentArtwork({...currentArtwork, emotion_tags: tags});
  };

  const toggleSituationTag = (tag) => {
    const tags = currentArtwork.situation_tags.includes(tag)
      ? currentArtwork.situation_tags.filter(t => t !== tag)
      : [...currentArtwork.situation_tags, tag];
    setCurrentArtwork({...currentArtwork, situation_tags: tags});
  };

  const handleSaveArtwork = async () => {
    if (!currentArtwork.artwork_name) {
      alert('작품명을 입력해주세요.');
      return;
    }
    if (!currentArtwork.artwork_image) {
      alert('작품 이미지를 업로드해주세요.');
      return;
    }
    if (currentArtwork.artwork_description && currentArtwork.artwork_description.length > 150) {
      alert('작품 소개는 150자를 초과할 수 없습니다.');
      return;
    }
    if (currentArtwork.emotion_tags.length === 0) {
      alert('감정 태그를 최소 1개 이상 선택해주세요.');
      return;
    }
    if (currentArtwork.situation_tags.length === 0) {
      alert('상황 태그를 최소 1개 이상 선택해주세요.');
      return;
    }

    try {
      const artistId = getCookie('yournest_a_id');
      let imageFilename = currentArtwork.artwork_image;

      // 새로운 이미지 파일인 경우 업로드
      if (currentArtwork.artwork_image instanceof File) {
        const formData = new FormData();
        formData.append('artwork_image', currentArtwork.artwork_image);

        const uploadResponse = await fetch(`${API_CONFIG.MAIN}/upload_artwork_image`, {
          method: 'POST',
          body: formData
        });

        if (!uploadResponse.ok) throw new Error('이미지 업로드 실패');
        const uploadData = await uploadResponse.json();
        imageFilename = uploadData.filename;
      }

      if (editingArtwork) {
        // 수정
        const response = await fetch(`${API_CONFIG.MAIN}/update_artwork`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            artwork_id: editingArtwork.id,
            artwork_name: currentArtwork.artwork_name,
            artwork_size: currentArtwork.artwork_size,
            artwork_year: currentArtwork.artwork_year,
            artwork_material: currentArtwork.artwork_material,
            artwork_description: currentArtwork.artwork_description,
            artwork_price: currentArtwork.artwork_price,
            artwork_image: imageFilename,
            emotion_tags: currentArtwork.emotion_tags,
            situation_tags: currentArtwork.situation_tags
          })
        });

        if (!response.ok) throw new Error('작품 수정 실패');
        alert('작품이 수정되었습니다.');
      } else {
        // 추가
        if (artworks.length >= 20) {
          alert('작품은 최대 20개까지 등록할 수 있습니다.');
          return;
        }

        const response = await fetch(`${API_CONFIG.MAIN}/create_artwork`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            artist_id: artistId,
            artwork_name: currentArtwork.artwork_name,
            artwork_size: currentArtwork.artwork_size,
            artwork_year: currentArtwork.artwork_year,
            artwork_material: currentArtwork.artwork_material,
            artwork_description: currentArtwork.artwork_description,
            artwork_price: currentArtwork.artwork_price,
            artwork_image: imageFilename,
            emotion_tags: currentArtwork.emotion_tags,
            situation_tags: currentArtwork.situation_tags
          })
        });

        if (!response.ok) throw new Error('작품 추가 실패');
        alert('작품이 추가되었습니다.');
      }

      // 작품 목록 새로고침
      await fetchArtworks();
      setPreviewUrl(null);
      setIsArtworkModalOpen(false);
      setEditingArtwork(null);
    } catch (error) {
      console.error('작품 저장 실패:', error);
      alert('작품 저장에 실패했습니다.');
    }
  };

  const handleDeleteArtwork = async (artwork) => {
    if (window.confirm('이 작품을 삭제하시겠습니까?')) {
      try {
        const response = await fetch(`${API_CONFIG.MAIN}/delete_artwork`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ artwork_id: artwork.id })
        });

        if (!response.ok) throw new Error('작품 삭제 실패');
        alert('작품이 삭제되었습니다.');

        // 작품 목록 새로고침
        await fetchArtworks();
      } catch (error) {
        console.error('작품 삭제 실패:', error);
        alert('작품 삭제에 실패했습니다.');
      }
    }
  };

  const handleSave = async () => {
    try {
      if (artistInfo.artist_description && artistInfo.artist_description.length > 300) {
        alert('작가 소개는 300자를 초과할 수 없습니다.');
        return;
      }

      const formattedInterests = Object.fromEntries(
        Object.entries(artistInfo.interests || {}).map(([key, value]) => [
          `b_${key.replace(/([A-Z])/g, '_$1').toLowerCase()}`,
          value ? 1 : 0
        ])
      );

      const response = await fetch(`${API_CONFIG.MAIN}/update_artist_info`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          artist_id: getCookie('yournest_a_id'),
          artist_name: artistInfo.artist_name,
          artist_company: artistInfo.artist_company,
          artist_email: artistInfo.artist_email,
          artist_phone: artistInfo.artist_phone,
          artist_description: artistInfo.artist_description,
          artist_address: artistInfo.artist_address,
          artist_lat: artistInfo.artist_lat,
          artist_lng: artistInfo.artist_lng,
          artist_website: artistInfo.artist_website,
          tour_available: artistInfo.tour_available ? 1 : 0,
          tour_address: artistInfo.tour_address,
          ...formattedInterests
        })
      });

      if (!response.ok) throw new Error('작가 정보 수정 실패');
      const data = await response.json();
      
      if (data.isSuccess) {
        alert('작가 정보가 수정되었습니다.');
        fetchArtistInfo();
      }
    } catch (error) {
      console.error('작가 정보 수정 실패:', error);
      alert('작가 정보 수정에 실패했습니다.');
    }
  };

  return (
    <div className="artist-mypage">
      <TopMenu 
        isAuthenticated={isAuthenticated}
        userType={userType}
        searchKeyword={searchKeyword}
        setSearchKeyword={setSearchKeyword}
        handleLogout={handleLogout}
      />

      <div className="artist-mypage__profile-block">
        <h2>작가 정보 수정</h2>
        
        <div className="artist-mypage__profile-block-item">
          <div className="artist-mypage__profile-block-text">작가명</div>
          <input 
            className="artist-mypage__profile-block-input"
            value={artistInfo.artist_name || ''}
            onChange={(e) => setArtistInfo({...artistInfo, artist_name: e.target.value})}
          />
        </div>

        <div className="artist-mypage__profile-block-item">
          <div className="artist-mypage__profile-block-text">소속 (갤러리, 협회 등)</div>
          <input 
            className="artist-mypage__profile-block-input"
            value={artistInfo.artist_company || ''}
            onChange={(e) => setArtistInfo({...artistInfo, artist_company: e.target.value})}
          />
        </div>

        <div className="artist-mypage__profile-block-item">
          <div className="artist-mypage__profile-block-text">이메일</div>
          <input 
            className="artist-mypage__profile-block-input"
            value={artistInfo.artist_email || ''}
            onChange={(e) => setArtistInfo({...artistInfo, artist_email: e.target.value})}
          />
        </div>

        <div className="artist-mypage__profile-block-item">
          <div className="artist-mypage__profile-block-text">연락처</div>
          <input 
            className="artist-mypage__profile-block-input"
            value={artistInfo.artist_phone || ''}
            onChange={(e) => setArtistInfo({...artistInfo, artist_phone: e.target.value})}
          />
        </div>

        <div className="artist-mypage__profile-block-item">
          <div className="artist-mypage__profile-block-text">작가 소개 (최대 300자)</div>
          <textarea 
            className="artist-mypage__profile-block-textarea"
            value={artistInfo.artist_description || ''}
            onChange={(e) => setArtistInfo({...artistInfo, artist_description: e.target.value})}
          />
        </div>

        <div className="artist-mypage__profile-block-item">
          <div className="artist-mypage__profile-block-text">작품 분야</div>
          <div className="artist-mypage__profile-block-interests">
            {[
              ['westernPainting', '서양화'],
              ['koreanPainting', '한국화'],
              ['folkPainting', '민화'],
              ['waterPainting', '수채화'],
              ['printPainting', '판화'],
              ['sculpture', '조각'],
              ['calligraphy', '서예'],
              ['craft', '공예'],
              ['picture', '사진'],
              ['illustration', '일러스트']
            ].map(([key, label]) => (
              <div key={key} className="artist-mypage__profile-block-interest-item">
                <input
                  type="checkbox"
                  id={key}
                  checked={artistInfo?.interests?.[key] || false}
                  onChange={(e) => setArtistInfo({
                    ...artistInfo,
                    interests: {
                      ...(artistInfo?.interests || {}),
                      [key]: e.target.checked
                    }
                  })}
                />
                <label htmlFor={key}>{label}</label>
              </div>
            ))}
          </div>
        </div>

        <div className="artist-mypage__profile-block-item">
          <div className="artist-mypage__profile-block-text">아틀리에 투어 가능 여부</div>
          <div className="artist-mypage__profile-block-interest-item">
            <input
              type="checkbox"
              id="tour_available"
              checked={artistInfo.tour_available || false}
              onChange={(e) => setArtistInfo({...artistInfo, tour_available: e.target.checked})}
            />
            <label htmlFor="tour_available">투어 가능</label>
          </div>
          {artistInfo.tour_available && (
            <>
              <div className="artist-mypage__profile-block-text" style={{marginTop: '16px'}}>아틀리에 주소</div>
              <input
                className="artist-mypage__profile-block-input"
                value={artistInfo.tour_address || ''}
                onChange={(e) => setArtistInfo({...artistInfo, tour_address: e.target.value})}
                placeholder="아틀리에 주소를 입력하세요"
              />
            </>
          )}
        </div>

        <div className="artist-mypage__profile-block-item">
          <div className="artist-mypage__profile-block-text">작품 이미지 업로드 ({artworks.length}/20)</div>
          <div className="artist-mypage__artworks-container">
            <div className="artist-mypage__artworks-scroll">
              {artworks.map((artwork, index) => (
                <div key={index} className="artist-mypage__artwork-card">
                  <img
                    src={artwork.previewUrl || artwork.artwork_image}
                    alt={artwork.artwork_name}
                    className="artist-mypage__artwork-image"
                  />
                  <div className="artist-mypage__artwork-info">
                    <div className="artist-mypage__artwork-name">{artwork.artwork_name}</div>
                    {artwork.artwork_size && (
                      <div className="artist-mypage__artwork-detail">크기: {artwork.artwork_size}cm</div>
                    )}
                    {artwork.artwork_year && (
                      <div className="artist-mypage__artwork-detail">제작년도: {artwork.artwork_year}년</div>
                    )}
                    {artwork.artwork_material && (
                      <div className="artist-mypage__artwork-detail">재료: {artwork.artwork_material}</div>
                    )}
                    {artwork.artwork_description && (
                      <div className="artist-mypage__artwork-description">{artwork.artwork_description}</div>
                    )}
                    {artwork.artwork_price && (
                      <div className="artist-mypage__artwork-price">{parseInt(artwork.artwork_price).toLocaleString()}원</div>
                    )}
                    {artwork.emotion_tags && artwork.emotion_tags.length > 0 && (
                      <div className="artist-mypage__artwork-tags">
                        <div className="artist-mypage__artwork-tags-label">감정:</div>
                        <div className="artist-mypage__artwork-tags-list">
                          {artwork.emotion_tags.map((tag, i) => (
                            <span key={i} className="artist-mypage__artwork-tag">{tag}</span>
                          ))}
                        </div>
                      </div>
                    )}
                    {artwork.situation_tags && artwork.situation_tags.length > 0 && (
                      <div className="artist-mypage__artwork-tags">
                        <div className="artist-mypage__artwork-tags-label">상황:</div>
                        <div className="artist-mypage__artwork-tags-list">
                          {artwork.situation_tags.map((tag, i) => (
                            <span key={i} className="artist-mypage__artwork-tag">{tag}</span>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="artist-mypage__artwork-actions">
                    <button onClick={() => openArtworkModal(artwork)}>수정</button>
                    <button onClick={() => handleDeleteArtwork(artwork)}>삭제</button>
                  </div>
                </div>
              ))}
              {artworks.length < 20 && (
                <div className="artist-mypage__artwork-add" onClick={() => openArtworkModal()}>
                  <div className="artist-mypage__artwork-add-icon">+</div>
                  <div>작품 추가</div>
                </div>
              )}
            </div>
          </div>
        </div>

        <div className="artist-mypage__button-block">
          <div
            className="artist-mypage__button-block-save"
            onClick={handleSave}
          >
            저장하기
          </div>
        </div>
      </div>

      {isArtworkModalOpen && (
        <div className="artist-mypage__modal-overlay" /* onMouseDown={handleModalBackgroundClick} */>
          <div className="artist-mypage__modal-content" onMouseDown={(e) => e.stopPropagation()}>
            <div className="artist-mypage__modal-header">
              <h3>{editingArtwork ? '작품 수정' : '작품 추가'}</h3>
              <button onClick={closeArtworkModal}>×</button>
            </div>

            <div className="artist-mypage__modal-body">
              <div className="artist-mypage__modal-field">
                <label>작품 이미지 *</label>
                <div className="artist-mypage__modal-field-subtext">
                  최소 가로 해상도: 1024px
                  <br />
                  포맷: JPG/JPEG/PNG</div>
                <input type="file" accept="image/jpeg,image/jpg,image/png" onChange={handleArtworkImageChange} />
                {previewUrl && (
                  <img
                    src={previewUrl}
                    alt="preview"
                    className="artist-mypage__modal-image-preview"
                  />
                )}
              </div>

              <div className="artist-mypage__modal-field">
                <label>작품명 *</label>
                <input
                  type="text"
                  value={currentArtwork.artwork_name}
                  onChange={(e) => setCurrentArtwork({...currentArtwork, artwork_name: e.target.value})}
                />
              </div>

              <div className="artist-mypage__modal-field">
                <label>작품 크기 (cm)</label>
                <input
                  type="text"
                  placeholder="예: 50x70"
                  value={currentArtwork.artwork_size}
                  onChange={(e) => setCurrentArtwork({...currentArtwork, artwork_size: e.target.value})}
                />
              </div>

              <div className="artist-mypage__modal-field">
                <label>제작년도</label>
                <input
                  type="number"
                  min="1900"
                  max={new Date().getFullYear()}
                  value={currentArtwork.artwork_year}
                  onChange={(e) => setCurrentArtwork({...currentArtwork, artwork_year: parseInt(e.target.value)})}
                />
              </div>

              <div className="artist-mypage__modal-field">
                <label>재료</label>
                <input
                  type="text"
                  placeholder="예: 캔버스에 유화"
                  value={currentArtwork.artwork_material}
                  onChange={(e) => setCurrentArtwork({...currentArtwork, artwork_material: e.target.value})}
                />
              </div>

              <div className="artist-mypage__modal-field">
                <label>작품 소개 (150자 이내)</label>
                <textarea
                  maxLength="150"
                  value={currentArtwork.artwork_description}
                  onChange={(e) => setCurrentArtwork({...currentArtwork, artwork_description: e.target.value})}
                />
                <div className="artist-mypage__modal-char-count">{currentArtwork.artwork_description.length}/150</div>
              </div>

              <div className="artist-mypage__modal-field">
                <label>작품 가격 (KRW)</label>
                <input
                  type="number"
                  min="0"
                  placeholder="원"
                  value={currentArtwork.artwork_price}
                  onChange={(e) => setCurrentArtwork({...currentArtwork, artwork_price: e.target.value})}
                />
              </div>

              <div className="artist-mypage__modal-field">
                <label>감정 태그 * (최소 1개 이상)</label>
                <div className="artist-mypage__modal-tags">
                  {emotionTags.map(tag => (
                    <button
                      key={tag}
                      className={currentArtwork.emotion_tags.includes(tag) ? 'active' : ''}
                      onClick={() => toggleEmotionTag(tag)}
                    >
                      {tag}
                    </button>
                  ))}
                </div>
              </div>

              <div className="artist-mypage__modal-field">
                <label>상황 태그 * (최소 1개 이상)</label>
                <div className="artist-mypage__modal-tags">
                  {situationTags.map(tag => (
                    <button
                      key={tag}
                      className={currentArtwork.situation_tags.includes(tag) ? 'active' : ''}
                      onClick={() => toggleSituationTag(tag)}
                    >
                      {tag}
                    </button>
                  ))}
                </div>
              </div>
            </div>

            <div className="artist-mypage__modal-footer">
              <button onClick={closeArtworkModal}>취소</button>
              <button onClick={handleSaveArtwork}>{editingArtwork ? '수정' : '추가'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
